import { Component } from '@angular/core';
import { TranslateDirective, TranslatePipe as NgxTranslatePipe } from '@ngx-translate/core';
import { ModalNotificationImageDirective } from '../../image/modal-notification-image.directive';

@Component({
  imports: [
    TranslateDirective,
    NgxTranslatePipe,
    ModalNotificationImageDirective
  ],
  selector: 'td-wb-modal-notification-fhsa-account',
  templateUrl: 'modal-notification-fhsa-account.component.html',
  styleUrls: [
    '../modal-notification-common.component.scss'
  ]
})
export class ModalNotificationFhsaAccountComponent {
}
